import { types } from "../types/types";

const initialState = {
  checking: true,
  nominasLabelFilter: [],
  cashflowCollapsedCategories: [],
  firstTimeOnApp: false,
  showWelcomeModal: false,
  modulePermissions: [], // Permisos de módulos desde admin panel
  blockedFeatures: [], // Features bloqueadas desde admin panel
  // false = aún no se obtuvo respuesta de GetMyPermissions en esta sesión.
  // Mientras esté false, NO debemos aplicar bloqueos por defecto en el front
  // (el backend valida igual). Esto evita falsos NoAccess durante el F5.
  modulePermissionsLoaded: false,
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.authLogin:
      return {
        ...state,
        ...action.payload,
        checking: false,
      };
    case types.authLogout:
      return {
        checking: false,
      };
    case types.updateNominasFilter:
      return {
        ...state,
        nominasLabelFilter: action.payload
      }
    case types.updateCashflowCollapsedCategories:
      return {
        ...state,
        cashflowCollapsedCategories: action.payload,
      };
    case types.authFirstTime:
      return {
        ...state,
        firstTimeOnApp: action.payload
      };
    case types.authShowWelcomeModal:
      return {
        ...state,
        showWelcomeModal: action.payload
      };
    case types.updateModulePermissions:
      return {
        ...state,
        modulePermissions: action.payload?.modulePermissions || [],
        blockedFeatures: action.payload?.blockedFeatures || [],
        modulePermissionsLoaded: true,
      };
    default:
      return state;
  }
};
